import React, { useState, useEffect } from 'react'
import "../Styles/Home.css"
import axios from "axios";
import * as FileSaver from 'file-saver';
import { showToast } from './Toast';
import { getUserDetails, findRole } from '../Utility/AsyncStorage';
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { Tooltip } from 'react-tooltip'
// import { X, Download, CalendarDays } from "lucide-react";

const DashboardCard = ({ title, value, icon }) => {
  return (
    <div className="card">
      <div className="icon">{icon}</div>
      <h3>{title}</h3>
      <p>{value}</p>
    </div>
  );
};
function Home() {

  const location = useLocation();

  const navigate = useNavigate();
  var userdetails = getUserDetails()
  const yesterday = new Date();

  const [showReqFlag, setShowReqFlag] = useState(false)
  const [pandingRequestData, setPandingRequestData] = useState([])
  const [showRequestData, setShowRequestData] = useState({})

  const [isOpen, setIsOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloading, setDownloading] = useState(false);

  const today = new Date().toISOString().split("T")[0];

  const handleClose = () => {
    setIsOpen(false);
    setFromDate("");
    setToDate("");
  };

  const company = { ...location.state } ?? {};
  // console.log('comp_num:', company.comp_num, userdetails.role);

  if (userdetails.role === "ADMIN") {
    company.comp_num = userdetails.comp_num;
  }
  else if (userdetails.role === "REGIONAL ADMIN") {

    company.comp_num = userdetails.assigned_companies;

  }

  const [userList, setUserList] = useState([])

  const [stats, setStats] = useState([
    { title: "Machines on Field", value: 0, icon: "📡", dec: "totalMachinesOnField" },
    { title: "Active Machines", value: 0, icon: "🏭", dec: 'totalMachinesLive' },
    { title: "Machines on Alert", value: 0, icon: "⚠️", dec: 'machinesOnAlert' },
    { title: "Inactive for 10+ Days", value: 0, icon: "📅", dec: "offlineDevices" },
    { title: "Total Companies", value: 0, icon: "🏢", dec: "companyCount" },
  ])

  const dashboardApi = async () => {

    try {

      let url = "https://itlapi.flovation.in/user/dashboardSuperAdmin";
      let body = {
        comp_num: company.comp_num
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("statsData", response.data.op[0])
            setStats(prevStats =>
              prevStats.map(stat => ({
                ...stat,
                value: response.data.op[0][stat.dec] || 0
              }))
            );
          }
          else {
            console.log("statsData", response.data.msg)
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("statsData if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("statsData else", error)
      })
    } catch (error) {
      console.log("statsData", error)
    }

  }

  const UserLoginList = async () => {
    try {

      let url = "https://itlapi.flovation.in/user/fetchUserLoginList";
      let body = {
        user_num: "",
        role: "",
        is_active: "",
        comp_num: company.comp_num,
        fromDate: "",
        toDate: ""
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("statsData", response.data.op)
            setUserList(response.data.op)

          }
          else {
            console.log("statsData", response.data.msg)
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("statsData if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("statsData else", error)
      })
    } catch (error) {
      console.log("statsData", error)
    }

  }

  const getRequestData = async () => {
    try {

      let url = "https://itlapi.flovation.in/user/fetchPendingRequest";
      let body = {
      }

      // console.log("getRequestData body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("getRequestData", response.data.op)
            setPandingRequestData(response.data.op)
          }
          else {
            // console.log("getRequestData", response.data.msg)
            // showToast(response.data.msg, 3000, "red");
            setPandingRequestData([])
            setShowReqFlag(false)
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getRequestData", error)
        if (error.response.status === 403) {
          console.log("getRequestData if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getRequestData else", error)
      })
    } catch (error) {
      console.log("getRequestData", error)
    }
  }

  const EditRequestData = (item, index) => {

    const oldData = JSON.parse(item.old_data);
    const newData = JSON.parse(item.new_data);
    var allKeys = {}
    if (item.type === 'Machine') {
      allKeys = Object.keys(oldData).filter(key => (key !== "mid" && key !== "device_id" && key !== "doa" && key !== "is_active" && key !== "is_edited" && key !== "edited_by"));
    }
    else if (item.type === 'Company') {
      allKeys = Object.keys(oldData);
    }

    // console.log("allKeys ", allKeys)

    return (
      <div key={index}>
        <div style={{ height: "60vh", overflowY: 'scroll', width: "100%", justifyContent: "space-between" }}>
          <div className='CampareData' style={{ justifyContent: "space-between", display: "flex" }}>
            <div style={{ width: "98%" }} >
              <h2>original data</h2>
              {allKeys.map((key, idx) => (
                <h3 style={{
                  backgroundColor: (newData[key] == oldData[key] ? "transparent" : "#f8dedb"), //red
                }} className='block-data'>
                  <span style={{ color: "#666", textTransform: "capitalize" }}>{key.replace(/_/g, " ")}:</span>{" "}
                  <span style={{ fontWeight: "bold", color: "#333", marginLeft: "6px" }}>{oldData[key]}</span>
                </h3>
              ))}
            </div>
            <div style={{ width: "98%" }} >
              <h2>Requested data</h2>
              {allKeys.map((key, idx) => (
                <h3 className='block-data' style={{
                  backgroundColor: (newData[key] == oldData[key] ? "transparent" : "#cff2f1"),//green
                }}>
                  <span style={{ color: "#666", textTransform: "capitalize" }}>{key.replace(/_/g, " ")}:</span>{" "}
                  <span style={{ fontWeight: "bold", color: "#333", marginLeft: "6px" }}>{newData[key]}</span>
                </h3>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-3 mt-4">
          <button
            className="px-4 py-2 bg-gray-300 rounded-md"
            onClick={() => { setShowRequestData({}) }}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-md"
            onClick={() => submitRequest(item, false)}
          >
            Reject
          </button>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded-md"
            onClick={() => submitRequest(item, true)}
          >
            Accept
          </button>
        </div>
      </div>
    );
  }

  const submitRequest = async (item, status) => {
    try {

      let url = "https://itlapi.flovation.in/user/updatePendingRequest";
      let body = {
        type: item.type,
        update_id: item.update_id,
        acceptFlag: status
      }

      // console.log("submitRequest body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("submitRequest", response.data.msg)
            setShowRequestData({})
            getRequestData()

          }
          else {
            console.log("submitRequest", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setShowRequestData({})
            getRequestData()
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("submitRequest", error)
        if (error.response.status === 403) {
          console.log("submitRequest if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("submitRequest else", error)
      })
    } catch (error) {
      console.log("submitRequest", error)
    }
  }

  const handleDownload = async () => {
    if (!fromDate || !toDate || downloading) return;
    setDownloading(true);
    showToast("Report Processing Started, Please Wait", 1000, "green");

    try {
      const url = "https://itlapi.flovation.in/overviewReport/dailyOverviewReport";

      const response = await axios.get(url, {
        params: {
          from_date: fromDate,
          to_date: toDate,
        },
        headers: {
          'authorization': `${userdetails.access_token}`
        },
        responseType: 'blob',
      });

      // If the API sent back a JSON message (e.g. no data) instead of a file, show it
      const contentType = response.headers['content-type'] || "";
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        const json = JSON.parse(text);
        showToast(json.msg || "No data found for selected dates", 3000, "red");
        return;
      }

      const blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel',
      });
      const name = `ITL_Daily_Overview_Report_${fromDate}_to_${toDate}.xlsx`;
      FileSaver.saveAs(blob, name);

      showToast("Download Report successfully", 3000, "green");
      handleClose();

    } catch (error) {
      console.log("handleDownload", error);
      if (error.response?.status === 403) {
        showToast("Session Time Out", 3000, "red");
        navigate("/");
      } else {
        showToast("Failed to download report", 3000, "red");
      }
    } finally {
      setDownloading(false);
    }
  }

  useEffect(() => {
    dashboardApi()
    UserLoginList()
    getRequestData()

    const interval = setInterval(() => {
      dashboardApi()
      UserLoginList()
    }, 5 * 60 * 1000); // 5 minutes = 300000 ms

    return () => clearInterval(interval);
  }, []);

  return (
    <div >
      <div style={{ position: "absolute", top: 20, right: 20, display: 'flex', justifyContent: 'flex-end' }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, textTransform: "uppercase", color: "#3e3b3b", position: 'relative', marginRight: 15 }} className="companyName-in-dashboard">{company ? company.company_name : ""}</h2>

        <div className='px-3 py-1  rounded-lg flex align-center'>
          {userdetails.role == "SUPER ADMIN" &&
            <i class="fa fa-bell"
              data-tooltip-content="Show Request"
              data-tooltip-id="my-tooltip-edit" onClick={() => { setShowReqFlag(true); }}>
              {pandingRequestData.length > 0 ?
                <h4 style={{ position: 'relative', top: -30, left: 10, color: "#f04646", fontWeight: 700, fontSize: 18 }}>{pandingRequestData.length}</h4>
                : <></>}
            </i>
          }

          {userdetails.comp_num === 11 &&
            <i class="fa-solid fa-file-arrow-down px-4"
              data-tooltip-content="Download OverView Report"
              data-tooltip-id="my-tooltip-edit"
              onClick={() => setIsOpen(true)}

            ></i>
          }

          <Tooltip id="my-tooltip-edit" />
        </div>
      </div>

      {isOpen && (
        <div className="overlay">

          <div className="form-box">

            {/* Header - same as Machine page "Report Download" modal */}
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Report Download</h2>
              <button
                onClick={handleClose}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>

            {/* Same layout as Utility/Report.js */}
            <div>
              <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
                <input
                  type="date"
                  value={fromDate}
                  max={today}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    if (toDate && e.target.value > toDate) {
                      setToDate("");
                    }
                  }}
                  className="w-80 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
                <input
                  type="date"
                  value={toDate}
                  min={fromDate}
                  max={today}
                  onChange={(e) => setToDate(e.target.value)}
                  className="w-80 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <button
                onClick={handleDownload}
                disabled={!fromDate || !toDate || downloading}
                className={`w-full px-4 py-2 rounded font-medium transition-all duration-200
                  ${!fromDate || !toDate
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"                 // dates not selected
                    : downloading
                      ? "bg-blue-800 text-white cursor-wait"                         // after click (downloading)
                      : "bg-blue-500 text-white hover:bg-blue-600 active:bg-blue-800 active:scale-[0.98] shadow-md" // ready / hover / press
                  }`}
              >
                {downloading ? (
                  <>
                    <i className="fa fa-spinner fa-spin text-[15px] px-2"></i>
                    Downloading...
                  </>
                ) : (
                  <>
                    <i className="fa fa-download text-[15px] px-2"></i>
                    Download Report
                  </>
                )}
              </button>
            </div>

          </div>
        </div>
      )
      }

      <div className="dashboard">
        {stats
          .filter(stat => !(userdetails.role === "ADMIN" && stat.dec === "companyCount"))
          .map((stat, index) => (
            <DashboardCard key={index} title={stat.title} value={stat.value} icon={stat.icon} />
          ))}

      </div>

      <div className="p-2 w-full mx-auto h-3/5">
        {userList.length == 0 ?
          <></>
          :
          <div className="overflow-scroll bg-white shadow-md rounded-xl p-4">

            <div className='flex justify-between align-center'>
              <h1 className="text-xl font-bold uppercase">User login list</h1>

            </div>


            <div className="p-6 w-full mx-auto user-block" style={{ maxHeight: '370px', overflowY: "scroll", scrollbarWidth: "thin" }} >

              {/* Table View for md+ screens */}
              <div className="overflow-hidden bg-white shadow-md rounded-xl tableview">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-200 text-black text-sm uppercase border-b">
                      <th className="px-6 py-3 text-left">User Company</th>
                      <th className="px-6 py-3 text-left">User</th>
                      <th className="px-6 py-3 text-left">Contact No.</th>
                      <th className="px-6 py-3 text-left">Role</th>
                      <th className="px-6 py-3 text-left">Duration</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700 text-sm">
                    {userList.map((company, index) => (
                      <tr key={index} className="border-b hover:bg-gray-50 transition">
                        <td className="px-6 py-3">{company.company_name}</td>
                        <td className="px-6 py-3">{company.name}</td>
                        <td className="px-6 py-3">{company.phone}</td>
                        <td className="px-6 py-3">{findRole(company.role)}</td>
                        <td className="px-6 py-3 font-medium">{company.total_duration}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Card View for small screens */}
              <div className=" space-y-4 mobileview">
                {userList.map((company, index) => (
                  <div key={index} className="bg-white shadow-md rounded-xl p-4 border">
                    <div className="text-sm text-gray-700">
                      <div className="mb-2">
                        <span className="font-semibold">User Company: </span>{company.company_name}
                      </div>
                      <div className="mb-2">
                        <span className="font-semibold">User: </span>{company.name}
                      </div>
                      <div className="mb-2">
                        <span className="font-semibold">Contact no: </span>{company.phone}
                      </div>
                      <div className="mb-2">
                        <span className="font-semibold">Role: </span>{findRole(company.role)}
                      </div>
                      <div>
                        <span className="font-semibold">Duration: </span>{company.total_duration}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>


          </div>
        }
      </div>

      {
        showReqFlag &&
        <div className="overlay">
          <div className="form-box" style={{ width: "80%" }}>
            {pandingRequestData.length == 0 ?
              <div>
                <h1 style={{ textAlign: "center", fontSize: 18, fontWeight: 700 }}>No Requests Pending at the Moment</h1>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-md" style={{ width: "20%", margin: "0 80%" }}
                  onClick={() => { setShowReqFlag(false) }}
                >
                  Cancel
                </button>
              </div> :
              <div className="font-mono text-sm">
                <div className='flex justify-between align-center font-bold mb-4 text-6xl card-request'>
                  <h1>Request</h1>
                  <i
                    className="fa fa-close text-[15px]"
                    onClick={() => setShowReqFlag(false)}
                  ></i>
                </div>
                <div className='bg-gray-200 p-2 mt-5 mb-2 rounded request-head' >
                  <div className='flex align-center font-bold'>
                    <h1 style={{ width: "15%" }}>Type </h1>
                    <h1 style={{ width: "25%" }}>Name</h1>
                    <h1 style={{ width: "20%" }}>Edit by</h1>
                    <h1 style={{ width: "25%" }}>Time</h1>
                    <h1 style={{ width: "15%" }}></h1>
                  </div>
                </div>
                {
                  pandingRequestData.map((item, index) => (
                    <div key={index} className=' px-2 mt-5 mb-2 rounded shadow-md block1'>
                      <div className='py-2 flex align-center justify-between requestCard' style={{ alignItems: "center" }}>
                        <h1 style={{ width: "15%" }}><span>Type </span> {item.type}</h1>
                        <h1 style={{ width: "25%" }}><span>Name </span> {item.type == "Machine" ? item.machine_name : item.company_name}</h1>
                        <h1 style={{ width: "20%" }}><span>Edit by </span> {item.edited_by ?? 0}</h1>
                        <h1 style={{ width: "25%" }}><span>Time </span> {item.doa ?? 0}</h1>
                        <button style={{ width: "15%", textAlign: 'center', alignItems: "center" }} onClick={() => { setShowRequestData(item); }} className='px-3 py-2 bg-rose-300 rounded-md'>
                          Show Details
                        </button>
                      </div>
                    </div>
                    // EditRequestData(item, index)
                  ))}


              </div>}
          </div>
        </div>
      }

      {
        Object.keys(showRequestData).length ?
          <div className="overlay">
            <div className="form-box" style={{ width: "800px" }}>
              <div className="grid grid-cols-2 gap-4 p-4 font-mono text-sm">
                <div className='flex align-center justify-evenly mb-4 block-lable'>
                  <div style={{ fontWeight: "bold", color: "#333", fontSize: "16px" }}>Orignal data</div>
                  <div style={{ fontWeight: "bold", color: "#333", fontSize: "16px" }}>Requested Data</div>
                </div>
                {
                  EditRequestData(showRequestData, 1)
                }
              </div>
            </div>
          </div>
          :
          <></>
      }
    </div >
  )
}

export default Home